export default __webpack_public_path__ + "static/media/tokenomic.c602faea.png";